import { render, staticRenderFns } from "./CarsByChassis.vue?vue&type=template&id=51ed4d0a&scoped=true&"
import script from "./CarsByChassis.vue?vue&type=script&lang=ts&"
export * from "./CarsByChassis.vue?vue&type=script&lang=ts&"
import style0 from "./CarsByChassis.vue?vue&type=style&index=0&id=51ed4d0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed4d0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSpacer})
